import { updateObject } from '../utility';

const initialState = {
    data: null,
}

const setDialCode = (state, action) => {
    return updateObject(state, {data: action.data});
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case 'SET_DIAL_CODE_DATA': return setDialCode(state, action);
        default: return state;
    }
};

export default reducer;